import { useCallback, useEffect, useRef, useState } from 'react';
import { journeyNoticeApi } from '../../api/journeyNoticeApi';
import { normalizeUnreadCount } from './journeyNoticeModel';

export function useJourneyNoticeUnreadCount(journeyId) {
  const generation = useRef(0);
  const [unreadCount, setUnreadCount] = useState(null);

  const refresh = useCallback(async () => {
    const scopedId = String(journeyId || '');
    if (!/^[1-9]\d*$/.test(scopedId)) {
      setUnreadCount(null);
      return null;
    }
    const requestId = ++generation.current;
    try {
      const payload = await journeyNoticeApi.getUnreadCount(scopedId);
      if (requestId !== generation.current) return null;
      const next = normalizeUnreadCount(payload).unreadCount;
      setUnreadCount(next);
      return next;
    } catch {
      if (requestId !== generation.current) return null;
      setUnreadCount(null);
      return null;
    }
  }, [journeyId]);

  useEffect(() => {
    refresh();
    return () => { generation.current += 1; };
  }, [refresh]);

  return { unreadCount, refresh };
}
